package com.exura.features.plandefinition.data.mappers.plandefinition

import com.exura.features.plandefinition.data.remote.dto.element.PersistentElementDto
import com.exura.features.plandefinition.domain.model.element.PersistentElement
import dev.gitlive.firebase.firestore.CollectionReference
import org.jetbrains.compose.resources.imageResource

/**
 * Mapper for converting between PersistentElement domain model and DTO.
 * Implements PlanElementMappers for Firebase storage compatibility.
 */
class PersistentElementMappers : PlanElementMappers<PersistentElement, PersistentElementDto> {
    override fun toDto(model: PersistentElement): PersistentElementDto = PersistentElementDto(
        elementType = model.elementType.name,
        durationInMinutes = model.durationInMinutes,
        durationInDays = model.durationInDays(),
        startRelativeDay = model.startRelativeDay,
        endRelativeDay = model.endRelativeDay,
        startRelativeHourOfDay = model.startRelativeHourOfDay,
        endRelativeHourOfDay = model.endRelativeHourOfDay,
        title = model.title,
        description = model.description,
        icon = model.icon,
        imageUrl = model.imageUrl,
    )

    override fun toDomain(dto: PersistentElementDto, collection: CollectionReference?, id: String?): PersistentElement = PersistentElement(
        firebaseDocId = id,
        firebaseDocPrefix = collection,
        startRelativeDay = dto.startRelativeDay,
        endRelativeDay = dto.endRelativeDay,
        startRelativeHourOfDay = dto.startRelativeHourOfDay,
        endRelativeHourOfDay = dto.endRelativeHourOfDay,
        title = dto.title,
        description = dto.description,
        icon = dto.icon,
        durationInMinutes = dto.durationInMinutes,
        imageUrl = dto.imageUrl,
    )
}
